/*
 * $Id:: model.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { takeLatest, put, all, call, select } from 'redux-saga/effects';

import { LITERALS_SLICE_NAME } from '../../app/constants';
import { globals as globalsSlice } from '../../app/globalsSlice';
import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME as AUTH_SLICE_NAME } from '../AuthenticatedPage/constants';
import { SLICE_NAME as ACCOUNT_SLICE_NAME } from '../MyAccountPage/constants';
import { SLICE_NAME } from './constants';
import { authenticateUser, requestLogoutHydraRequest, logoutAuthenticatedUser } from './service';

function* getDefaultLanguage() {
    const globals = yield select(globalsSlice);
    const { supportedLanguages } = globals.globals;
    return (!!supportedLanguages && Object.keys(supportedLanguages)[0]) || 'en';
}

function* requestLoginUser(action) {
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(authenticateUser, action.payload);
    const { error } = response;
    if (!error) {
        yield put({ type: `${SLICE_NAME}/loading`, payload: false });
        // TODO: Remove hard coded consts like LOGIN_SUCCESS
        yield put({ type: `${SLICE_NAME}/response`, payload: { ...response, fromAction: 'LOGIN_SUCCESS' } });
    } else {
        if (error.description === 'account.not.verified') {
            yield put({ type: `${AUTH_SLICE_NAME}/credentials`, payload: action.payload });
        }
        yield put({ type: `${SLICE_NAME}/error`, payload: error.description });
        yield put({ type: `${SLICE_NAME}/loading`, payload: false });
    }
}

function* login() {
    yield takeLatest(`${SLICE_NAME}/login`, requestLoginUser);
}

function* logoutUser(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(logoutAuthenticatedUser, action.payload);
    if (!response.error) {
        const defaultLanguage = yield getDefaultLanguage();
        const me = yield select(meSlice);
        const userLanguage = me.language;
        const actions = [
            put({ type: `${SLICE_NAME}/authLogout`, payload: response }),
            put({ type: `${AUTH_SLICE_NAME}/me`, payload: {} }),
            put({ type: `${SLICE_NAME}/token`, payload: null }),
            put({ type: `${ACCOUNT_SLICE_NAME}/details`, payload: {} }),
            put({ type: `${ACCOUNT_SLICE_NAME}/childAccounts`, payload: {} }),
        ];
        if (userLanguage !== defaultLanguage) {
            actions.unshift(put({ type: `${LITERALS_SLICE_NAME}/fetchLiterals`, payload: { language: defaultLanguage } }));
        }
        yield all(actions);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* logout() {
    yield takeLatest(`${SLICE_NAME}/logout`, logoutUser);
}

function* getLogoutRedirect(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    yield put({ type: `${SLICE_NAME}/revokeTokens`, payload: null });
    const response = yield call(requestLogoutHydraRequest, action.payload);
    const error = response.error || null;
    if (!error) {
        yield put({ type: `${SLICE_NAME}/response`, payload: { type: 'LOGOUT_REDIRECT', ...response } });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestLogoutRedirect() {
    yield takeLatest(`${SLICE_NAME}/requestLogoutRedirect`, getLogoutRedirect);
}

export { login, logout, requestLogoutRedirect };
